// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"149":"6314df62","453":"1cba01d4"}[chunkId] + ".chunk.js";
};